(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
/**
 * Bundle Builder Component
 * Manages a bundle builder interface with collection tabs, product selection, and cart integration
 */
class BundleBuilderComponent {
  /**
   * Required references to DOM elements
   * @type {string[]}
   */
  requiredRefs = ['collectionTabs', 'productsGrid', 'bundleItems', 'addToCartBtn', 'mobileCartBtn'];

  /**
   * Bundle items array
   * @type {Array<BundleItem>}
   */
  #bundleItems = [];

  /**
   * Discount tiers configuration
   * @type {Array<DiscountTier>}
   */
  #discountTiers = [];

  /**
   * Current active tab index
   * @type {number}
   */
  #activeTabIndex = 0;

  /**
   * Component configuration
   * @type {BundleBuilderConfig}
   */
  #config = {};

  /**
   * DOM references
   * @type {Object}
   */
  #refs = {};

  /**
   * Constructor
   * @param {HTMLElement} element - The component element
   */
  constructor(element) {
    this.element = element;
    this.#initialize();
  }

  /**
   * Initialize the bundle builder component
   * @private
   */
  #initialize() {
    this.#loadConfiguration();
    this.#setupRefs();
    this.#setupEventListeners();
    this.#setupTabAnimation();
    this.#updateButtonStates();
    this.#scrollActiveTabIntoView();
    this.#setupMobileCartVisibility();
  }

  /**
   * Setup DOM references
   * @private
   */
  #setupRefs() {
    this.#refs = {
      collectionTabs: this.element.querySelector('[ref="collectionTabs"]'),
      productsGrid: this.element.querySelector('[ref="productsGrid"]'),
      bundleItems: this.element.querySelector('[ref="bundleItems"]'),
      addToCartBtn: this.element.querySelector('[ref="addToCartBtn"]'),
      mobileCartBtn: this.element.querySelector('[ref="mobileCartBtn"]')
    };
  }

  /**
   * Load configuration from section settings and data attributes
   * @private
   */
  #loadConfiguration() {
    const section = this.element.closest('[id="bundle-builder"]');
    if (!section) return;

    this.#config = {
      currencySymbol: section.dataset.currencySymbol || '$',
      currencyCode: section.dataset.currencyCode || 'USD',
      locale: section.dataset.locale || 'en-US',
      moneyFormat: section.dataset.moneyFormat || "${{amount}}",
      addToBundleText: this.element.dataset.addToBundleText || 'Zum Bundle hinzufügen',
      addedToBundleText: this.element.dataset.addedToBundleText || 'Zum Bundle hinzugefügt',
      emptyBundleText: this.element.dataset.emptyBundleText || 'Füge Artikel hinzu, um dein eigenes Bundle zu erstellen',
      addToCartText: this.element.dataset.addToCartText || 'Bundle in den Warenkorb'
    };

    // Load discount tiers from section settings
    const rawTiers = [
      {
        minProducts: parseInt(this.element.getAttribute('data-discount-1-min-products')) || 0,
        percent: parseInt(this.element.getAttribute('data-discount-1-percent')) || 0
      },
      {
        minProducts: parseInt(this.element.getAttribute('data-discount-2-min-products')) || 0,
        percent: parseInt(this.element.getAttribute('data-discount-2-percent')) || 0
      },
      {
        minProducts: parseInt(this.element.getAttribute('data-discount-3-min-products')) || 0,
        percent: parseInt(this.element.getAttribute('data-discount-3-percent')) || 0
      }
    ];
    
    this.#discountTiers = rawTiers.filter(tier => tier.minProducts > 0 && tier.percent > 0);
  }

  /**
   * Setup event listeners for user interactions
   * @private
   */
  #setupEventListeners() {
    // Tab switching
    this.#refs.collectionTabs?.addEventListener('click', this.#handleTabClick.bind(this));

    // Add to bundle buttons
    this.element.addEventListener('click', this.#handleAddToBundle.bind(this));

    // Remove from bundle buttons
    this.element.addEventListener('click', this.#handleRemoveFromBundle.bind(this));

    // Add bundle to cart
    this.#refs.addToCartBtn?.addEventListener('click', this.#handleAddBundleToCart.bind(this));

    // Mobile cart button
    this.#refs.mobileCartBtn?.addEventListener('click', this.#handleMobileCartClick.bind(this));
  }

  /**
   * Setup tab animation with sliding underline
   * @private
   */
  #setupTabAnimation() {
    const tabsContainer = this.#refs.collectionTabs;
    if (!tabsContainer) return;

    const tabs = tabsContainer.querySelectorAll('.bundle-builder__tab-button');
    
    tabs.forEach((tab, index) => {
      tab.addEventListener('mouseenter', () => {
        const tabRect = tab.getBoundingClientRect();
        const containerRect = tabsContainer.getBoundingClientRect();
        
        const left = tabRect.left - containerRect.left;
        const width = tabRect.width;
        
        tabsContainer.style.setProperty('--underline-left', `${left}px`);
        tabsContainer.style.setProperty('--underline-width', `${width}px`);
        tabsContainer.style.setProperty('--underline-opacity', '1');
      });
      
      tab.addEventListener('mouseleave', () => {
        // Return to active tab position or hide
        const activeTab = this.#getActiveTab();
        if (activeTab) {
          const tabRect = activeTab.getBoundingClientRect();
          const containerRect = tabsContainer.getBoundingClientRect();
          
          const left = tabRect.left - containerRect.left;
          const width = tabRect.width;
          
          tabsContainer.style.setProperty('--underline-left', `${left}px`);
          tabsContainer.style.setProperty('--underline-width', `${width}px`);
          tabsContainer.style.setProperty('--underline-opacity', '1');
        } else {
          tabsContainer.style.setProperty('--underline-opacity', '0');
        }
      });
    });
    
    // Set initial position for active tab
    const activeTab = this.#getActiveTab();
    if (activeTab) {
      const tabRect = activeTab.getBoundingClientRect();
      const containerRect = tabsContainer.getBoundingClientRect();
      
      const left = tabRect.left - containerRect.left;
      const width = tabRect.width;
      
      tabsContainer.style.setProperty('--underline-left', `${left}px`);
      tabsContainer.style.setProperty('--underline-width', `${width}px`);
      tabsContainer.style.setProperty('--underline-opacity', '1');
    }
  }

  /**
   * Handle tab click events
   * @param {Event} event - The click event
   * @private
   */
  #handleTabClick(event) {
    const tabButton = event.target.closest('.bundle-builder__tab-button');
    if (!tabButton) return;

    const tabIndex = parseInt(tabButton.dataset.tabIndex);
    this.#switchTab(tabIndex);
  }

  /**
   * Handle add to bundle button clicks
   * @param {Event} event - The click event
   * @private
   */
  #handleAddToBundle(event) {
    const addBtn = event.target.closest('.bundle-builder__add-btn');
    if (!addBtn) return;

    const productData = this.#extractProductData(addBtn);
    if (!productData) return;

    // Check if item already exists
    if (this.#bundleItems.find(item => item.id === productData.id)) {
      this.#showNotification('This item is already in your bundle!', 'warning');
      return;
    }

    this.#addToBundle(productData);
  }

  /**
   * Handle remove from bundle button clicks
   * @param {Event} event - The click event
   * @private
   */
  #handleRemoveFromBundle(event) {
    const removeBtn = event.target.closest('.bundle-builder__remove-btn');
    if (!removeBtn) return;

    const productId = removeBtn.dataset.productId;
    this.#removeFromBundle(productId);
  }

  /**
   * Handle add bundle to cart button click
   * @param {Event} event - The click event
   * @private
   */
  #handleAddBundleToCart(event) {
    event.preventDefault();
    
    if (this.#bundleItems.length === 0) return;
    
    this.#addBundleToCart();
  }

  /**
   * Handle mobile cart button click
   * @param {Event} event - The click event
   * @private
   */
  #handleMobileCartClick(event) {
    event.preventDefault();
    
    // Animate the mobile cart button
    const mobileCartBtn = this.element.querySelector('.bundle-builder__mobile-cart-btn');
    if (mobileCartBtn) {
      this.#animateAddToCart(mobileCartBtn);
    }
    
    this.#addBundleToCart();
  }

  /**
   * Extract product data from button element
   * @param {HTMLElement} button - The add to bundle button
   * @returns {BundleItem | null} The extracted product data
   * @private
   */
  #extractProductData(button) {
    try {
      return {
        id: button.dataset.productId,
        title: button.dataset.productTitle,
        price: parseFloat(button.dataset.productPrice),
        image: button.dataset.productImage,
        handle: button.dataset.productHandle
      };
    } catch (error) {
      console.error('Error extracting product data:', error);
      return null;
    }
  }

  /**
   * Add a product to the bundle
   * @param {BundleItem} productData - The product data to add
   * @private
   */
  #addToBundle(productData) {
    this.#bundleItems.push(productData);
    this.#updateBundleDisplay();
    this.#updateButtonStates();
    this.#dispatchBundleUpdateEvent();
  }

  /**
   * Remove a product from the bundle
   * @param {string} productId - The ID of the product to remove
   * @private
   */
  #removeFromBundle(productId) {
    this.#bundleItems = this.#bundleItems.filter(item => item.id !== productId);
    this.#updateBundleDisplay();
    this.#updateButtonStates();
    this.#dispatchBundleUpdateEvent();
  }

  /**
   * Switch to a different collection tab
   * @param {number} tabIndex - The index of the tab to switch to
   * @private
   */
  #switchTab(tabIndex) {
    // Update tab buttons
    const tabButtons = this.#refs.collectionTabs?.querySelectorAll('.bundle-builder__tab-button');
    tabButtons?.forEach((btn, index) => {
      btn.classList.toggle('bundle-builder__tab-button--active', index === tabIndex);
    });

    // Update product grids
    const productGrids = this.#refs.productsGrid?.querySelectorAll('.bundle-builder__collection-products');
    productGrids?.forEach((grid, index) => {
      grid.classList.toggle('bundle-builder__collection-products--active', index === tabIndex);
    });

    this.#activeTabIndex = tabIndex;
    
    // Update button states after a small delay to ensure DOM is updated
    setTimeout(() => {
      this.#updateButtonStates();
    }, 10);
    
    // Update underline position
    const tabsContainer = this.#refs.collectionTabs;
    if (tabsContainer) {
      const activeTab = this.#getActiveTab();
      if (activeTab) {
        const tabRect = activeTab.getBoundingClientRect();
        const containerRect = tabsContainer.getBoundingClientRect();
        
        const left = tabRect.left - containerRect.left;
        const width = tabRect.width;
        
        tabsContainer.style.setProperty('--underline-left', `${left}px`);
        tabsContainer.style.setProperty('--underline-width', `${width}px`);
        tabsContainer.style.setProperty('--underline-opacity', '1');
      }
    }
  }

  /**
   * Update the bundle display with current items
   * @private
   */
  #updateBundleDisplay() {
    const bundleItemsContainer = this.#refs.bundleItems;
    const subtotalElement = this.element.querySelector('.bundle-builder__subtotal-amount');
    const discountElement = this.element.querySelector('.bundle-builder__discount-amount');
    const totalElement = this.element.querySelector('.bundle-builder__total-amount');
    const addToCartBtn = this.#refs.addToCartBtn;

    // Mobile cart button
    const mobileCartBtn = this.element.querySelector('.bundle-builder__mobile-cart-btn');

    if (this.#bundleItems.length === 0) {
      bundleItemsContainer.innerHTML = `<p class="bundle-builder__empty-message">${this.#config.emptyBundleText}</p>`;
      if (subtotalElement) subtotalElement.textContent = this.#formatMoney(0);
      if (discountElement) discountElement.textContent = this.#formatMoney(0);
      if (totalElement) totalElement.textContent = this.#formatMoney(0);
      if (addToCartBtn) addToCartBtn.disabled = true;
      
      // Update mobile cart button
      if (mobileCartBtn) mobileCartBtn.disabled = true;
      
      // Update mobile cart visibility
      this.#updateMobileCartVisibility();
      return;
    }

    // Calculate totals
    const subtotal = this.#bundleItems.reduce((sum, item) => sum + item.price, 0);
    const discountPercent = this.#getDiscountPercent(this.#bundleItems.length);
    const discount = Math.round(subtotal * discountPercent / 100);
    const total = subtotal - discount;

    // Update bundle items display
    bundleItemsContainer.innerHTML = this.#bundleItems.map(item => this.#createBundleItemHTML(item)).join('');

    // Update totals display
    if (subtotalElement) subtotalElement.textContent = this.#formatMoney(subtotal);
    if (discountElement) discountElement.textContent = `- ${this.#formatMoney(discount)}`;
    if (addToCartBtn) addToCartBtn.disabled = false;
    if (totalElement) totalElement.textContent = this.#formatMoney(total);
    
    // Update mobile cart button
    if (mobileCartBtn) mobileCartBtn.disabled = false;
    
    // Update mobile cart visibility
    this.#updateMobileCartVisibility();
  }

  /**
   * Create HTML for a bundle item
   * @param {BundleItem} item - The bundle item
   * @returns {string} The HTML string for the item
   * @private
   */
  #createBundleItemHTML(item) {
    return `
      <div class="bundle-builder__item">
        <div class="bundle-builder__item-image">
          <img src="${item.image}" alt="${item.title}" loading="lazy">
        </div>
        <div class="bundle-builder__item-info">
          <h4 class="bundle-builder__item-title">${item.title}</h4>
          <p class="bundle-builder__item-price">${this.#formatMoney(item.price)}</p>
        </div>
        <button class="bundle-builder__remove-btn" data-product-id="${item.id}" aria-label="Remove ${item.title} from bundle">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path class="remove-icon-bottom" d="M11.5 9v4.25M8.5 9v4.25M5.75 12.2V6h8.5c0 2.421 0 3.779 0 6.2 0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.911a2.498 2.498 0 0 1-.983 1.017c-.197.1-.458.17-.911.207-.463.037-1.057.038-1.91.038h-.4c-.853 0-1.447 0-1.91-.038-.453-.037-.714-.106-.911-.207a2.498 2.498 0 0 1-.984-1.017c-.1-.197-.17-.458-.207-.911C5.75 13.647 5.75 13.053 5.75 12.2z" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
            <path class="remove-icon-top" d="M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    `;
  }

  /**
   * Update button states based on current bundle
   * @private
   */
  #updateButtonStates() {
    const addButtons = this.element.querySelectorAll('.bundle-builder__add-btn');
    
    addButtons.forEach(button => {
      const productId = button.dataset.productId;
      const isInBundle = this.#bundleItems.find(item => item.id === productId);
      
      const arrowSvg = `
        <div class="bundle-builder__arrow-wrapper">
          <svg class="bundle-builder__arrow" width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path class="bundle-builder__arrow-line" d="M0 5H9" stroke="currentColor" stroke-width="2"/>
            <path class="bundle-builder__arrow-tip" d="M6 1L10 5L6 9" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>`;

      if (isInBundle) {
        button.disabled = true;
        button.innerHTML = `<span>${this.#config.addedToBundleText}</span>${arrowSvg}`;
      } else {
        button.disabled = false;
        button.innerHTML = `<span>${this.#config.addToBundleText}</span>${arrowSvg}`;
      }
    });
  }

  /**
   * Get the discount percentage for a given number of products
   * @param {number} productCount - The number of products in the bundle
   * @returns {number} The discount percentage
   * @private
   */
  #getDiscountPercent(productCount) {
    let percent = 0;
    this.#discountTiers.forEach(tier => {
      if (productCount >= tier.minProducts && tier.percent > percent) {
        percent = tier.percent;
      }
    });
    return percent;
  }

  /**
   * Format money amount
   * @param {number} amount - Amount in cents
   * @returns {string} Formatted money string
   * @private
   */
  #formatMoney(amount) {
    // Get the format string from Shopify
    let moneyFormat = this.#config.moneyFormat || "{{amount}} €";
    
    // Convert cents to dollars/euros
    const value = (amount / 100).toFixed(2);
    
    // Use comma if Shopify says so, otherwise use dot
    let formatted;
    if (moneyFormat.includes('amount_with_comma_separator')) {
      formatted = parseFloat(value).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return moneyFormat.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, formatted);
    } else if (moneyFormat.includes('amount')) {
      formatted = parseFloat(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, formatted);
    }
    
    // fallback
    return parseFloat(value).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  /**
   * Add the current bundle to the cart
   * @private
   */
  async #addBundleToCart() {
    if (this.#bundleItems.length === 0) return;

    const addToCartBtn = this.#refs.addToCartBtn;
    if (!addToCartBtn) return;

    // Show loading state
    addToCartBtn.disabled = true;

    try {
      const formData = {
        items: this.#bundleItems.map(item => ({
          id: parseInt(item.id),
          quantity: 1
        }))
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Animate the add to cart button
      this.#animateAddToCart(addToCartBtn);

      // Reset the bundle after a delay to show the animation
      setTimeout(() => {
        this.#bundleItems = [];
        this.#updateBundleDisplay();
        this.#updateButtonStates();
      }, 1500);

      // Update cart and open drawer
      await this.#updateCartAndOpenDrawer();

      // Dispatch cart update event
      this.#dispatchCartUpdateEvent(data);

    } catch (error) {
      console.error('Error adding bundle to cart:', error);
      this.#showNotification('Error adding bundle to cart. Please try again.', 'error');
    } finally {
      // Reset button state after animation
      setTimeout(() => {
        if (addToCartBtn) {
          addToCartBtn.disabled = this.#bundleItems.length === 0;
        }
      }, 2000);
    }
  }

  /**
   * Animate the add to cart button
   * @param {HTMLElement} button - The add to cart button
   * @private
   */
  #animateAddToCart(button) {
    if (!button) return;

    // Add the animation class
    button.classList.add('atc-added');

    // Remove the animation class after animation completes
    setTimeout(() => {
      button.classList.remove('atc-added');
    }, 1500);
  }

  /**
   * Update cart and open cart drawer
   * @private
   */
  async #updateCartAndOpenDrawer() {
    const oldCartDrawer = document.querySelector('cart-drawer');
    
    if (oldCartDrawer) {
      try {
        // Fetch and replace the entire cart drawer section
        const response = await fetch('/?section_id=cart-drawer');
        const html = await response.text();
        
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const newCartDrawer = tempDiv.querySelector('cart-drawer');
        
        if (newCartDrawer) {
          oldCartDrawer.replaceWith(newCartDrawer);
          
          setTimeout(() => {
            if (typeof newCartDrawer.open === 'function') {
              newCartDrawer.open();
            } else {
              newCartDrawer.classList.add('active');
            }
          }, 50);
        }

        // Update cart icon bubble
        await this.#updateCartIconBubble();

      } catch (error) {
        console.error('Error updating cart drawer:', error);
        // Fallback to cart page
        window.location.href = '/cart';
      }
    } else {
      // If no cart drawer, redirect to cart page
      window.location.href = '/cart';
    }
  }

  /**
   * Update cart icon bubble with latest cart state
   * @private
   */
  async #updateCartIconBubble() {
    try {
      const response = await fetch('/?section_id=cart-icon-bubble');
      const html = await response.text();
      
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const newCartIconSection = tempDiv.querySelector('#shopify-section-cart-icon-bubble');
      const oldCartIconSection = document.getElementById('shopify-section-cart-icon-bubble');
      
      if (newCartIconSection && oldCartIconSection) {
        oldCartIconSection.replaceWith(newCartIconSection);
      }

      // Always fetch the latest cart state and update the count
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      const countBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      if (countBubble) {
        countBubble.textContent = cart.item_count;
      }

      // Dispatch a custom event for any theme listeners
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

    } catch (error) {
      console.error('Error updating cart icon bubble:', error);
    }
  }



  /**
   * Get the currently active tab
   * @returns {HTMLElement | null} The active tab element
   * @private
   */
  #getActiveTab() {
    return this.#refs.collectionTabs?.querySelector('.bundle-builder__tab-button--active') || null;
  }

  /**
   * Scroll the active tab into view
   * @private
   */
  #scrollActiveTabIntoView() {
    const tabsContainer = this.#refs.collectionTabs;
    const activeTab = this.#getActiveTab();
    
    if (tabsContainer && activeTab) {
      const tabLeft = activeTab.offsetLeft;
      const tabWidth = activeTab.offsetWidth;
      const containerWidth = tabsContainer.offsetWidth;
      tabsContainer.scrollLeft = tabLeft - (containerWidth / 2) + (tabWidth / 2);
    }
  }

  /**
   * Show a notification message
   * @param {string} message - The message to show
   * @param {string} type - The type of notification (success, warning, error)
   * @private
   */
  #showNotification(message, type = 'info') {
    // Create a simple notification element
    const notification = document.createElement('div');
    notification.className = `bundle-builder__notification bundle-builder__notification--${type}`;
    notification.textContent = message;
    
    // Add to the page
    document.body.appendChild(notification);
    
    // Remove after 3 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove();
      }
    }, 3000);
  }

  /**
   * Dispatch bundle update event
   * @private
   */
  #dispatchBundleUpdateEvent() {
    const event = new CustomEvent('bundle:update', {
      bubbles: true,
      detail: {
        items: this.#bundleItems,
        itemCount: this.#bundleItems.length
      }
    });
    this.element.dispatchEvent(event);
  }

  /**
   * Dispatch cart update event
   * @param {Object} cartData - The cart data
   * @private
   */
  #dispatchCartUpdateEvent(cartData) {
    const event = new CustomEvent('cart:updated', {
      bubbles: true,
      detail: {
        cart: cartData,
        source: 'bundle-builder',
        itemCount: cartData.item_count
      }
    });
    document.dispatchEvent(event);
  }

  /**
   * Setup mobile cart visibility based on screen size
   * @private
   */
  #setupMobileCartVisibility() {
    const mobileCart = this.#refs.mobileCartBtn;
    if (!mobileCart) return;

    const updateMobileCartVisibility = () => {
      if (window.innerWidth <= 768) {
        mobileCart.style.display = 'block';
        if (this.#bundleItems.length > 0) {
          mobileCart.classList.add('bundle-builder__mobile-cart--visible');
          mobileCart.classList.remove('bundle-builder__mobile-cart--hidden');
        } else {
          mobileCart.classList.remove('bundle-builder__mobile-cart--visible');
          mobileCart.classList.add('bundle-builder__mobile-cart--hidden');
        }
      } else {
        mobileCart.style.display = 'none';
        mobileCart.classList.remove('bundle-builder__mobile-cart--visible', 'bundle-builder__mobile-cart--hidden');
      }
    };

    // Initial setup
    updateMobileCartVisibility();

    // Listen for window resize
    window.addEventListener('resize', updateMobileCartVisibility);
  }

  /**
   * Update mobile cart visibility based on current bundle state
   * @private
   */
  #updateMobileCartVisibility() {
    const mobileCart = this.#refs.mobileCartBtn;
    if (!mobileCart) return;

    if (window.innerWidth <= 768) {
      mobileCart.style.display = 'block';
      if (this.#bundleItems.length > 0) {
        mobileCart.classList.add('bundle-builder__mobile-cart--visible');
        mobileCart.classList.remove('bundle-builder__mobile-cart--hidden');
      } else {
        mobileCart.classList.remove('bundle-builder__mobile-cart--visible');
        mobileCart.classList.add('bundle-builder__mobile-cart--hidden');
      }
    }
  }
}

/**
 * Bundle item data structure
 * @typedef {Object} BundleItem
 * @property {string} id - The product variant ID
 * @property {string} title - The product title
 * @property {number} price - The product price in cents
 * @property {string} image - The product image URL
 * @property {string} handle - The product handle
 */

/**
 * Discount tier configuration
 * @typedef {Object} DiscountTier
 * @property {number} minProducts - Minimum number of products for this discount
 * @property {number} percent - Discount percentage
 */

/**
 * Bundle builder configuration
 * @typedef {Object} BundleBuilderConfig
 * @property {string} currencySymbol - Currency symbol
 * @property {string} currencyCode - Currency code
 * @property {string} locale - Locale string
 * @property {string} moneyFormat - Money format string
 * @property {string} addToBundleText - Text for add to bundle button
 * @property {string} addedToBundleText - Text for added to bundle button
 * @property {string} emptyBundleText - Text for empty bundle message
 * @property {string} addToCartText - Text for add to cart button
 */

// Initialize bundle builder when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Initialize existing bundle builders
  document.querySelectorAll('.bundle-builder-section').forEach(section => {
    const bundleBuilderElement = section.querySelector('bundle-builder-component');
    if (bundleBuilderElement) {
      new BundleBuilderComponent(bundleBuilderElement);
    }
  });

  // Enhanced tab functionality for better UX
  document.querySelectorAll('.bundle-builder-section').forEach(section => {
    const tabsContainer = section.querySelector('.bundle-builder__collection-tabs');
    if (!tabsContainer) return;

    // On tab click, scroll the tab into view and update active class
    tabsContainer.querySelectorAll('.bundle-builder__tab-button').forEach((tab, idx) => {
      tab.addEventListener('click', function() {
        // Remove active class from all tabs
        tabsContainer.querySelectorAll('.bundle-builder__tab-button').forEach(btn => 
          btn.classList.remove('bundle-builder__tab-button--active')
        );
        
        // Add active class to clicked tab
        tab.classList.add('bundle-builder__tab-button--active');
        
        // Smooth scroll the tab into view
        tab.scrollIntoView({ behavior: 'smooth', inline: 'center' });
        
        // Update product grids visibility
        const productsGrid = section.querySelector('.bundle-builder__products-grid');
        if (productsGrid) {
          productsGrid.querySelectorAll('.bundle-builder__collection-products').forEach((grid, i) => {
            grid.classList.toggle('bundle-builder__collection-products--active', i === idx);
          });
          
          // Scroll to top of active tab content
          const activeGrid = productsGrid.querySelector('.bundle-builder__collection-products--active');
          if (activeGrid) {
            activeGrid.scrollIntoView({ block: 'start' });
          }
        }
      });
    });

    // On load, scroll the active tab into view
    const activeTab = tabsContainer.querySelector('.bundle-builder__tab-button--active');
    if (activeTab) {
      // Calculate the horizontal scroll position so the active tab is centered
      const tabLeft = activeTab.offsetLeft;
      const tabWidth = activeTab.offsetWidth;
      const containerWidth = tabsContainer.offsetWidth;
      tabsContainer.scrollLeft = tabLeft - (containerWidth / 2) + (tabWidth / 2);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
